<template>
  <div class="event-page page">
    <div v-if="!loading && !is403Error" class="popular-services-page">
      <ServicesHeader :title="$t('services.popularServices.title')" />
      <div class="popular-services-page__inner container">
        <div class="popular-services-page__list">
          <PopularServiceComponent
            v-for="(item, i) in popularServices"
            :key="i"
            :data="item"
          />
        </div>
      </div>
    </div>
    <div class="event-page__loading page-loading" v-else-if="loading">
      {{ $t("services.loading") }}
    </div>
    <div class="event-page__loading page-loading" v-else-if="is403Error">
      {{ $t("services.error403") }}
    </div>
  </div>
</template>

<script>
import ServicesHeader from "@/components/Custom/ServicesHeader.vue";
import PopularServiceComponent from "@/components/Custom/PopularServiceComponent.vue";
import apiServices from "@/api/services";
import { mapGetters } from "vuex";

export default {
  name: "PopularServicesPage",
  components: {
    PopularServiceComponent,
    ServicesHeader
  },
  data() {
    return {
      loading: true,
      popularServices: [],
      is403Error: false
    };
  },
  computed: {
    ...mapGetters("services", ["currency"]),
    ...mapGetters("event", ["eventId"])
  },
  methods: {
    async getPopularServices() {
      try {
        this.loading = true;
        const params = this.$route.params;
        const { data } = await apiServices.additionalServices(params.id, {
          is_popular: 1,
          page: 1,
          per_page: 1000
        });
        this.popularServices = data.filter(item =>
          item.prices.find(price => price.currency === this.currency.code)
        );
      } catch (e) {
        this.is403Error = e.error_data?.response?.status === 403;
      } finally {
        this.loading = false;
      }
    }
  },
  created() {
    this.getPopularServices();
  }
};
</script>

<style lang="scss">
.popular-services-page {
  min-height: 100%;
  flex-grow: 1;
  background-color: var(--gray, #f9f9f9);
  display: flex;
  flex-direction: column;
  box-sizing: border-box;

  * {
    box-sizing: border-box;
  }

  .container {
    width: 100%;
    @media (max-width: 740px) {
      width: auto;
    }
  }

  &__inner {
    padding: 50px 0;
    flex-grow: 1;
    @media (max-width: 540px) {
      padding: 30px 0;
    }
  }

  &__list {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    margin: -15px;
    margin-top: 15px;

    @media (max-width: 999px) {
      grid-template-columns: repeat(2, 1fr);
    }

    @media (max-width: 640px) {
      grid-template-columns: repeat(1, 1fr);
    }

    @media (max-width: 540px) {
      margin: -8px;
    }
  }
}
</style>
